function parseStringAsHtml(content, selector = 'template') {
    const domParser = new DOMParser();
    const parsed = domParser.parseFromString(content, 'text/html');
    return parsed.querySelector(selector) || parsed.body;
}
export default parseStringAsHtml;
